module.exports = __webpack_public_path__ + "img/LouisPasteur.9d75313e.jpg";